import { Equivalence } from "./equivalence.model";

export class Tableau {
  tableauId: number;
  fromProgrammeId: number;
  toProgrammeId: number;
  notes: string;
  equivalences: Equivalence[];
}
